import { render } from "./CourseChapterEdit.vue?vue&type=template&id=9a7e961c&scoped=true"
import script from "./CourseChapterEdit.vue?vue&type=script&lang=js"
export * from "./CourseChapterEdit.vue?vue&type=script&lang=js"

import "./CourseChapterEdit.vue?vue&type=style&index=0&id=9a7e961c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a7e961c"]])

export default __exports__